import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { CaptionProps } from '@widgets/ArticleTextbox/types'

const StyledCaption = styled.div`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    font-family: ${sourceSansPro};
    font-size: 14px;
    line-height: 1.4;
    font-weight: normal;
    color: ${grey_100};
    p {
      font-family: ${sourceSansPro};
      font-size: 14px;
      line-height: 1.4;
      font-weight: normal;
      color: ${grey_100};
      margin: 0px;
    }
  `}
`

const Caption: FunctionComponent<CaptionProps> = ({ children }) => {
  return (
    <StyledCaption
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  )
}

export default Caption
